import {RouteKey} from 'common/src/modules/routing/routing.enums';
import {RouteDef} from 'common/src/modules/routing/routing.types';
import createXmlSection from 'common/src/modules/shared/copilot/utils/formatters/createXmlSection';

function formatRouteDefs(routeDefs: Record<RouteKey, RouteDef>) {
  return Object.entries(routeDefs)
    .map(([routeKey, route]) => {
      let content = `Route Key: ${routeKey}
Display Name: ${route.displayName}
Path: ${route.path}
`;

      if (route.pathParams.length === 0) {
        content += 'Path parameters: None';
      } else {
        content += 'Path parameters:\n';
        content += route.pathParams.map((param) => `- ${_formatPathParam(param)}`).join('\n');
      }

      content += '\n';

      if (route.queryParams.length === 0) {
        content += 'Query parameters: None';
      } else {
        content += 'Query parameters:\n';
        content += route.queryParams.map((param) => `- ${_formatQueryParam(param)}`).join('\n');
      }

      return createXmlSection({tagName: 'route', content, indentContent: true}).trimStart();
    })
    .join('\n\n');
}

// Example pathParam: {key: 'campaignId', type: 'number', displayName: 'Campaign ID', defaultValue: '12345'}
// This would format to: "campaignId (number, optional)"
function _formatPathParam(param: RouteDef['pathParams'][0]) {
  return `${param.key} (${param.type}, ${param.defaultValue ? 'optional' : 'required'})`;
}

// Example queryParam: {key: 'status', type: 'one of', enumValues: ['active', 'paused', 'archived'], required: false, defaultValue: 'active'}
// This would format to: "status (one of: [active, paused, archived], optional)"
function _formatQueryParam(param: RouteDef['queryParams'][0]) {
  return `${param.key} (${param.type}${param.enumValues ? `: [${param.enumValues.join(', ')}]` : ''}, ${param.required ? 'required' : 'optional'})`;
}

export default formatRouteDefs;
